// Accepts an optional injectable `window` reference so the "no window"
// fallback branch (SSR / build-time rendering) can be exercised in tests.
// jsdom exposes `window` as a non-configurable global self-reference, which
// makes it impossible to stub out via `Object.defineProperty` in a jsdom
// test environment.
export const safeLocation = (
  win = typeof window !== 'undefined' ? window : null
) => {
  if (win) return win.location
  return {
    href: null,
    search: null,
    path: null,
    hash: null,
  }
}
